<template>
  <div>
    <step-1 v-if="step == 1" @next="next" :nextData="backData" ref="step1Ref"></step-1>
    <step-2 v-else-if="step == 2" @backPage="back" :backData="nextData" @settledStep="back" ref="step2Ref"></step-2>
  </div>
</template>

<script>
import step1 from './stepPage/step1';
import step2 from './stepPage/step2';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    step1,
    step2
  },
  data() {
    return {
      step: '',
      nextData: {},
      backData: {}
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next(vm => {
  //     if (from.path == '/financialManage/groupFinanceSettlement/detail') {
  //       vm.step = 2;
  //     } else {
  //       if (vm.nextData.reportId) {
  //         vm.step = 2;
  //       } else if (vm.backData.reportId) {
  //         vm.step = 1;
  //       } else {
  //         vm.step = vm.$route.query.step;
  //       }
  //     }
  //   });
  // },
  created() {
    this.setPageTitle(this.$route.query.reportName);
    this.step = this.$route.query.step;
  },
  methods: {
    // 上一步
    back(data) {
      this.nextData = {};
      this.backData = data;
      this.step = 1;
      this.$nextTick(() => {
        this.$refs.step1Ref.getData();
      });
    },

    // 下一步
    next(data) {
      this.nextData = data;
      this.backData = {};
      this.step = 2;
      this.$nextTick(() => {
        this.$refs.step2Ref.setData();
      });
    }
  }
};
</script>
